<template>
    <div class="ticket-main-section flex-grow-1 d-flex overflow-hidden">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TicketMainSection"
    }
</script>

<style lang="scss">
    .ticket-main-section {
        background: #fff !important;

        .card {
            margin-bottom: 20px;
            border-radius: 8px;

            .card-body {
                padding: 17px;
            }
        }
    }
</style>
